import {
  projectLanguageToSurveyLocale,
  type SurveyLocale,
} from '@/shared-utilities/survey-locale';

/**
 * Kept here instead of importing the full shared i18n catalog so manager
 * bundles only the URL-question strings they need.
 */
const URL_QUESTION_TEXT_BY_LOCALE: Record<SurveyLocale, string> = {
  af: "Jy word nou na 'n nuwe bladsy verwys; klik hier as dit nie outomaties laai nie.",
  am: 'ወደ አዲስ ገጽ በቅርቡ ይመራሉ፣ በራስ-ሰር ካልጫነ እዚህ ይጫኑ።',
  ar: 'أنت على وشك إعادة التوجيه إلى صفحة جديدة، اضغط هنا إذا لم يتم تحميلها تلقائيًا.',
  az: 'Siz yeni səhifəyə yönləndirilirsiniz, avtomatik yüklənmirsə buraya klikləyin.',
  bg: 'Ще бъдете пренасочени към нова страница, кликнете тук, ако не се зареди автоматично.',
  bs: 'Bit ćete preusmjereni na novu stranicu, kliknite ovdje ako se ne učita automatski.',
  ca: 'Estàs a punt de ser redirigit a una nova pàgina; fes clic aquí si no es carrega automàticament.',
  cs: 'Budete přesměrováni na novou stránku, klikněte sem, pokud se nenačte automaticky.',
  da: 'Du bliver omdirigeret til en ny side, klik her, hvis den ikke indlæses automatisk.',
  de: 'Sie werden gleich auf eine neue Seite weitergeleitet. Klicken Sie hier, falls dies nicht automatisch geschieht.',
  el: 'Πρόκειται να ανακατευθυνθείτε σε νέα σελίδα. Κάντε κλικ εδώ αν δεν φορτωθεί αυτόματα.',
  en: 'You are about to be redirected to a new page, click here if it does not load automatically.',
  es: 'Estás a punto de ser redirigido a una nueva página, haz clic aquí si no se carga automáticamente.',
  et: 'Teid suunatakse uuele lehele, klõpsake siia, kui see ei laadi automaatselt.',
  eu: 'Orri berri batera birbideratuko zaituzte, egin klik hemen automatikoki kargatzen ez bada.',
  fi: 'Sinut ohjataan uudelle sivulle. Napsauta tätä, jos sivu ei lataudu automaattisesti.',
  fr: 'Vous allez être redirigé vers une nouvelle page, cliquez ici si elle ne se charge pas automatiquement.',
  gl: 'Estás a punto de ser redirixido a unha nova páxina; fai clic aquí se non se carga automaticamente.',
  gu: 'તમને નવા પેજ પર રીડાયરેક્ટ કરવામાં આવી રહ્યા છે, જો તે સ્વયં લોડ ન થાય તો અહીં ક્લિક કરો.',
  hr: 'Bit ćete preusmjereni na novu stranicu, kliknite ovdje ako se ne učita automatski.',
  hy: 'Դուք շուտով կվերահղվեք նոր էջ, սեղմեք այստեղ, եթե այն ինքնաբերաբար չբեռնվի։',
  it: 'Stai per essere reindirizzato a una nuova pagina, clicca qui se non si carica automaticamente.',
  ja: '新しいページにリダイレクトされます。自動的に読み込まれない場合はここをクリックしてください。',
  ka: 'თქვენ გადამისამართდებით ახალ გვერდზე, დაწკაპუნეთ აქ, თუ ავტომატურად არ ჩაიტვირთა.',
  ko: '새 페이지로 리디렉션됩니다. 자동으로 로드되지 않으면 여기를 클릭하세요.',
  ms: 'Anda akan dialihkan ke halaman baharu, klik di sini jika ia tidak dimuatkan secara automatik.',
  my: 'သင့်အား စာမျက်နှာအသစ်သို့ ပြန်ညွှန်းပေးမည်ဖြစ်ပြီး၊ အလိုအလျောက် load မဖြစ်ပါက ဤနေရာကို နှိပ်ပါ။',
  nl: 'Je wordt doorgestuurd naar een nieuwe pagina, klik hier als dit niet automatisch gebeurt.',
  pt: 'Você está prestes a ser redirecionado para uma nova página, clique aqui se ela não carregar automaticamente.',
  ru: 'Вы будете перенаправлены на новую страницу, нажмите здесь, если она не загрузится автоматически.',
  tl: 'Malapit ka nang mairedirect sa bagong pahina, i-click dito kung hindi ito awtomatikong mag-load.',
  uk: 'Вас буде переспрямовано на нову сторінку, натисніть тут, якщо вона не завантажиться автоматично.',
  vi: 'Bạn sẽ được chuyển hướng đến một trang mới, hãy nhấp vào đây nếu trang không tự động tải.',
  zh: '您即将被重定向到新页面，如果没有自动加载，请点击此处。',
};

export const URL_QUESTION_TEXT = URL_QUESTION_TEXT_BY_LOCALE.en;

export function getUrlQuestionText(
  language: string | null | undefined
): string {
  return URL_QUESTION_TEXT_BY_LOCALE[projectLanguageToSurveyLocale(language)];
}

const URL_QUESTION_TEXTS: ReadonlySet<string> = new Set(
  Object.values(URL_QUESTION_TEXT_BY_LOCALE)
);

export function isUrlQuestionText(text: string | null | undefined): boolean {
  return typeof text === 'string' && URL_QUESTION_TEXTS.has(text);
}
